export default "__VITE_ASSET__UkAuJUwl__"